<template>
    <div class="vue-location-marker-details">
        <div class="row">
            <div class="col-12">
                <p class="virtual-h3 mb-3">{{ marker.name }}</p>
            </div>

            <div class="col-12">
                <p class="mb-3">
                    {{ marker.streetName }} {{ marker.houseNumber }}<br>
                    {{ marker.postalCode }} {{ marker.place }}<br>
                    <a :href="marker.phoneNumber | phoneFormatter" @click.stop class="phone">{{ marker.phoneNumber }}</a>
                </p>

                <p class="opening-hours mb-3" :class="{ 'is-open': marker.openingHours.isOpen }">
                    <template v-if="hasOpeningHours">{{ translations.openToday }} - {{ marker.openingHours.currentDay.endhours }}</template>
                    <template v-if="! hasOpeningHours">{{ translations.closed }}</template>
                </p>

                <a :href="marker.url" class="btn-primary m-0" style="font-size: 1em; width: 100%;">{{  translations.goToLocation }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import PhoneNumberFormatter from "../../mixins/PhoneNumberFormatter";
import translations from "../../mixins/translations";

export default {
    name: "MarkerDetails",

    mixins: [PhoneNumberFormatter, translations],

    props: {
        marker: {
            type: Object,
            required: true
        },
    },

    computed: {
        hasOpeningHours() {
            return ! lodash.isNil(this.marker.openingHours.currentDay);
        }
    },

    filters: {
        distance(value) {
            return `${value.toFixed(2)} km`
        }
    },
}
</script>
